import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { PodcastsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const PODCASTS_QUERY = graphql`
query NodeAllPodcastsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Podcasts" } }) {
    nodes {
      data
    }
  }
}
`;

export const PodcastsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(PODCASTS_QUERY), 'items')}>{children}</Provider>;
};
